<template>
  <div class="main-navi">
    <secondary-list
      v-show="links.length > 0"
      class="main-navi__navi"
      data-track-as="navi.secondary"
      :links="links"
    />
    <sanitas-button
      v-if="cta"
      class="main-navi__cta"
      secondary
      :href="cta.href"
      :target="cta.target"
      rel="noopener"
    >
      {{ cta.title }}
    </sanitas-button>
  </div>
</template>

<script>
import SanitasButton from '@/components/sanitas-components/SanitasButton'

import SecondaryList from './SecondaryList'

export default {
  name: 'MainNavi',
  components: { SecondaryList, SanitasButton },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    cta: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="postcss">
.main-navi__navi {
  margin-bottom: var(--spacing-4);
}

.main-navi__cta {
  margin-bottom: var(--spacing-8);
}

@media (--lg) {
  .main-navi__navi,
  .main-navi__cta {
    margin-bottom: 0;
  }

  .main-navi__navi {
    display: flex;
    align-items: center;
  }
}
</style>
